export const BATCH_SIZE = 5
export const BYTES_PER_MEGABYTE = 1_000_000
export const PDF_MIME_TYPE = 'application/pdf'
